import { stages, stages_mobile } from "../../const";
import Button from "../ui/Button";
import { Text } from "../ui/Text";
import { useDeviceWidth } from "../../hooks/useDeviceWidth";
import Card from "../ui/Card";

function Stages() {
  const deviceWidth = useDeviceWidth();
  const isMobile = deviceWidth <= 1300;
  return (
    <div
      id="stages"
      className="sm:px-[30px] px-5 flex flex-col sm:gap-16 gap-8 w-full items-center scroll-m-5"
    >
      <Text type="title">Этапы работы</Text>
      {isMobile ? (
        <div className="scrollbar-hidden touch-scroll -mx-4 overflow-x-auto w-full">
          <div className="flex snap-x snap-mandatory gap-3">
            {stages_mobile.map((stage, index) => (
              <Card
                key={stage.pic}
                className="h-[350px] min-w-[280px] sm:h-[500px] sm:min-w-[400px] flex flex-col justify-between items-center"
              >
                <>
                  <div className="flex justify-between w-full">
                    <Text type="subtitle">{stage.title}</Text>
                    <Text type="subtitle">{`0${index + 1}`}</Text>
                  </div>
                  <img src={stage.pic} alt="pic" className="scale-75" />
                  <div className="w-full flex flex-col gap-4">
                    <Text type="main">{stage.description}</Text>
                    {stage?.cta ? <Button href="#form" className="w-fit" >
          Обсудить проект
        </Button> : null}
                  </div>
                </>
              </Card>
            ))}
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-12 w-full">
          {stages.map((stage) => (
            <div
              key={stage.pic}
              className="group py-7 px-8 flex justify-between hover:bg-white-transparent rounded-[20px] transition-all duration-500 h-[190px]"
            >
              <Text type="subtitle" className="relative w-full max-w-[300px]">
                <>
                  {stage.title}
                  <img
                    src={stage.pic}
                    alt={stage.title.toString()}
                    className="absolute left-[20vw] -top-[50%] opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                  />
                </>
              </Text>
              <div className="flex flex-col gap-11 items-start">
                <Text type="main" className="w-[560px]">
                  {stage.description}
                </Text>
                {stage.cta ? <Button href="#form">Связаться</Button> : null}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Stages;
